<template>
    <b-card  align="left" body-border-variant="white" border-variant="white"  body-class="p-0 rounded-top  border border-info" >
        <div ref="chart" style="width:100%;height:293px"></div>
    </b-card>
  </template>
  
  <script>
  import chinaJson from '@/assets/china.json';
  import shanXi from '@/assets/mapJson/140000.json'
import heNan from '@/assets/mapJson/410000.json'
import shannXi from '@/assets/mapJson/610000.json'
//使用name映射地图json文件
const jsonMap = {
    '陕西': shannXi,
    '山西': shanXi,
    '河南': heNan
}

import { multi } from '@/api/api.js'
  export default {
    name: 'chart-layout',
    props: {
        navs: {
            type:Array,
            default(){
                return []
            }
        },
        brand:{
            type:Object,
            default(){
                return null
            }
        },
        variant:{
            type:String,
            default(){
                return 'primary'
            }
        },
        type:{
            type:String,
            default(){
                return 'dark'
            }
        },
        sticky:{
            type:Boolean,
            default(){
                return true
            }
        },
        fixed:{
            type:String,
            default(){
                return 'top'
            }
        },
        navItemAlign:{
            type:String,
            default(){
                return 'left'
            }
        },
        config:{
            type:[Object,Array],
            default(){
                return null
             
            }
        }
    },
    mounted(){
        if(this.config.serviceName){
            
            this.getTypeMulti()
        }else{
            
            this.getEchartData()  
        }
    },
    computed:{
        xdataRun(){
            
            let xdata = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
            if(this.config.serviceName){
                xdata = []
                xdata = this.gaoXin.map(item => item.name)
                xdata = this.gaoXin.filter((item,index) => {
                    if(index < 10){
                        return true
                    }
                })
                xdata = xdata.map(item => item.name)

            }else{
                xdata = []
                xdata = this.zhuanJing.filter((item,index) => {
                    if(index < 10){
                        return true
                    }
                })
                xdata = xdata.map(item => item.name)

            }
            return xdata
        },
        datasRun(){
            let datas = [[22,22,33,78,12,56]]
            if(this.config.serviceName){
                datas = []
                datas = this.gaoXin.filter((item,index) => {
                    if(index < 10){
                        return true
                    }
                })
                datas = datas.map(item => item.value)

            }else{
                datas = []
                datas = this.zhuanJing.filter((item,index) => {
                    if(index < 10){
                        return true
                    }
                })
                datas = datas.map(item => item.value)

            }
            return datas
        },
        req(){
            let req = [{
                "serviceName":this.config.serviceName,
                "colNames":["*"],
                "condition":[],
                "relation_condition":{},
                "page":{"pageNo":1,"rownumber":this.config.pageRowNumber},
                // "group":[ 
                //     {
                //         "colName": "province",
                //         "type": "by"
                //     },
                //     {
                //         "colName": "id",
                //         "type": "count"
                //     }
                // ],
                "order":[],
                "draft":false
            }]
            if(this.config.hasOwnProperty('order')){
                req[0].order = this.config.order
            }
            if(this.config.hasOwnProperty('condition')){
                req[0].condition = this.config.condition
            }
            switch (this.templateType) {
                case '1':
                req['order']=[{
                    colName: "rank",
                    orderType: "asc"
                }]
                    break;
            
                default:
                    break;
            }
            return req
        }
    },
    data() {
      return {
        provinceName:"",
        
        gaoXin:[]
      }
    },
      methods: {
        getTypeMulti(){
            let req = this.req
                let app = 'fyzhmd'
            multi(req,app).then((res)=>{
                
                // console.log('---:',res)
                let resData = res.data
                if(res.state == "SUCCESS" && resData.length > 0){
                    let gaoXin = resData[0]
                    if(gaoXin.state == 'SUCCESS'){
                        this.gaoXin = []
                        for(let item of gaoXin.data){
                            this.gaoXin.push({
                                name:item.province,
                                value:item.declared_num
                            })
                        }


                        
                        this.getEchartData()  
                    }
                }
            })
        },
        getEchartData() {
            let self = this
            // this.$echarts.registerMap("china", chinaJson);
            const chart = this.$refs.chart
            if (chart) {
                const myChart = this.$echarts.init(chart)
                let xdata = self.xdataRun
                let datas = [self.datasRun]
                //5.echarts配置
                // console.log('chart layout',xdata,datas)
                let option = {
                    title: {
                        // text: "全国",
                        text: self.config.title,
                        // subtext: "全国",
                        // sublink: "http://www.pm25.in",
                        left: "center",
                        textStyle: {
                            color: "#000",
                            // backgroundColor: "linear-gradient(to top right, #f6f5f0, #fefefd)",height:40,
                                padding:5,
                            fontSize: "22",
                            lineHeight:40,
                        }
                        
                    },
                    xAxis: {
                        data: xdata,
                        axisLabel: {
                        show: true,
                        // formatter:'{value}人',
                        textStyle: {
                            color: '#9FA9BC',
                            //Y轴坐标的颜色
                            fontSize:8,
                        }
                        },
                        // axisLine: {
                        //     lineStyle: {
                        //             type: 'solid',
                        //             color: '#9FA9BC',
                        //             width: '1'
                        //         }
                        // },
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: -45, //倾斜度 -90 至 90 默认为0
                            margin: 5, //刻度标签与轴线之间的距离
                            textStyle: {
                            fontSize: 9, //横轴字体大小
                            color: "#000000",//颜色
                            },
                        }
                    },
                    yAxis: {
                        type: 'value',
                        // 不展示y轴
                        show: true,
                        // 不展示分割线
                        splitLine: {
                            show: true
                        },
                    },
                    series: [
                        {
                            type: 'bar', // 形状为柱状图
                            name:self.config.title,
                            data: datas[0],
                            // barWidth: 20,
                            itemStyle: {
                            normal: {
                                // 每根柱子颜色设置
                                color: function(params) {
                                    // console.log(params)
                                    const colorList = [
                                        '#28D1F4',
                                        '#28BA77',
                                        '#288DC9',
                                        '#F49D3F'
                                    ]
                                    let color = colorList[0]
                                    return color
                                }
                            }
                            }

                        }
                        ],
                        tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }, // 鼠标移上的阴影，默认是线
                        formatter: function(params) {
                            // console.log(params.color)
                            return "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:" + params[0].color + ";'></span> " + params[0].name + ': ' + params[0].value + '次'
                        }
                    }
                }
                myChart.setOption(option);
                // self.getEchartProvinceData('陕西')
                window.addEventListener("resize", function() {
                    myChart.resize();
                });
                myChart.on("click", function(chinaParam) {
                    // console.log(chinaParam)
                    // self.getEchartProvinceData(chinaParam.name)
                });
            }
        },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  